var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    d: "M17.656,1.563h-.937V0H15.156V1.563H4.844V0H3.281V1.563H2.344A2.346,2.346,0,0,0,0,3.906v13.75A2.346,2.346,0,0,0,2.344,20H17.656A2.346,2.346,0,0,0,20,17.656V3.906A2.346,2.346,0,0,0,17.656,1.563Zm.781,16.094a.782.782,0,0,1-.781.781H2.344a.782.782,0,0,1-.781-.781V7.344H18.438Zm0-11.875H1.563V3.906a.782.782,0,0,1,.781-.781h.938V4.688H4.844V3.125H15.156V4.688h1.563V3.125h.938a.782.782,0,0,1,.781.781Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    transform: "translate(2.809 9.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_823",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    width: 1,
    height: 2,
    transform: "translate(0.191 -0.281)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_826",
    transform: "translate(6.404 9.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    width: 2,
    height: 2,
    transform: "translate(-0.404 -0.281)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_828",
    transform: "translate(9.281 9.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_827",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    width: 2,
    height: 2,
    transform: "translate(-0.281 -0.281)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    transform: "translate(12.157 9.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    width: 2,
    height: 2,
    transform: "translate(-0.157 -0.281)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_832",
    transform: "translate(15.753 9.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    width: 1,
    height: 2,
    transform: "translate(0.247 -0.281)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_834",
    transform: "translate(2.809 12.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_833",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    width: 1,
    height: 2,
    transform: "translate(0.191 -0.157)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    transform: "translate(6.404 12.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_835",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    width: 2,
    height: 2,
    transform: "translate(-0.404 -0.157)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_838",
    transform: "translate(9.281 12.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_837",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    width: 2,
    height: 2,
    transform: "translate(-0.281 -0.157)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_840",
    transform: "translate(12.157 12.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_839",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    width: 2,
    height: 2,
    transform: "translate(-0.157 -0.157)"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_842",
    transform: "translate(2.809 15.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_841",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    width: 1,
    height: 1,
    transform: "translate(0.191 -0.034)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_844",
    transform: "translate(6.404 15.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_843",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    width: 2,
    height: 1,
    transform: "translate(-0.404 -0.034)"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    transform: "translate(9.281 15.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_845",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    width: 2,
    height: 1,
    transform: "translate(-0.281 -0.034)"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    transform: "translate(12.157 15.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_847",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    width: 2,
    height: 1,
    transform: "translate(-0.157 -0.034)"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_850",
    transform: "translate(15.753 12.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_849",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    width: 1,
    height: 2,
    transform: "translate(0.247 -0.157)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.0ea4a9251c7914c4dc501d01e43d14b8.svg";
export { ForwardRef as ReactComponent };